<template>
  <div>
    <v-container class="fill-height pa-0" fluid>
      <Loader :loading="loading"></Loader>
      <v-row class="fill-height pa-0 mx-0 my-auto">
        <v-col cols="12" class="d-flex pa-0 text-center justify-center">
          <p class="font-weight-bold neutral--text pb-4 pt-6">{{ 'Accept Order' }}</p>
        </v-col>
        <v-col cols="12" class="pa-0" v-if="!orderSubmitted">
          <v-form ref="form" v-model="valid" :lazy-validation="false">
            <v-row>
              <v-col cols="12">
                <label>Cost</label>
                <v-text-field
                  v-model="order.cost"
                  :placeholder="'Cost'"
                  outlined
                  clearable
                  :rules="requiredRule()"
                  class="required"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <label>Instructions</label>
                <v-textarea
                  v-model="order.instructions"
                  :placeholder="'instructions'"
                  outlined
                  clearable
                  :rules="requiredRule()"
                  class="required"
                ></v-textarea>
              </v-col>
              <v-col cols="12">
                <label>Phone</label>
                <v-text-field
                  v-model="order.phone"
                  :placeholder="'Phone'"
                  outlined
                  clearable
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <label>Email</label>
                <v-text-field
                  v-model="order.email"
                  :placeholder="'Email'"
                  outlined
                  clearable
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <label>Comments</label>
                <v-textarea
                  v-model="order.comments"
                  :placeholder="'Comments'"
                  outlined
                  clearable
                ></v-textarea>
              </v-col>
            </v-row>
          </v-form>

          <v-row style="width: 100%">
            <v-col cols="12">
              <v-btn
                :disabled="!valid"
                block
                depressed
                rounded
                large
                class="white--text font-weight-bold"
                color="black"
                @click="submitOrderOffer"
                >{{ $t('submit') }}
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
        <v-col v-else cols="12" class="pa-0">
          <v-alert dense text type="success">
            Offer <strong>successfully</strong> submitted
          </v-alert>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import EventBus from '@/helpers/event-bus';
import util from '@/mixins/util';
import Loader from '@/components/shared/helpers/Loader.vue';

export default {
  name: 'OrderAcceptedByProvider',
  components: { Loader },
  mixins: [util],
  data() {
    return {
      valid: false,
      loading: false,
      order: {
        uuid: null,
        publicContactEmail: null,
        cost: null,
        instructions: null,
        phone: null,
        email: null,
        comments: null,
        type: null,
      },
      orderSubmitted: false,
    };
  },
  mounted() {
    this.order.uuid = this.$route.query.uuid;
    this.order.publicContactEmail = this.$route.query.publicContactEmail;
    this.order.email = this.$route.query.publicContactEmail;
    this.order.type = this.$route.query.type;
  },
  methods: {
    submitOrderOffer() {
      this.loading = true;
      if (this.order.type === 'equipment') {
        this.axios
          .put('/api/v1/orders-equipment/accept-by-provider', this.order)
          .then(() => {
            console.log('Success');
            EventBus.$emit('snackbar', {
              text: 'Equipmet Offer successfully submitted',
            });
            this.orderSubmitted = true;
          })
          .catch(error => {
            console.log(error);
          })
          .finally((this.loading = false));
      } else if (this.order.type === 'patent') {
        this.axios
          .put('/api/v1/orders-patent/accept-by-provider', this.order)
          .then(() => {
            console.log('Success');
            EventBus.$emit('snackbar', {
              text: 'Patent Offer successfully submitted',
            });
            this.orderSubmitted = true;
          })
          .catch(error => {
            console.log(error);
          })
          .finally((this.loading = false));
      } else {
        this.axios
          .post('/api/v1/orders/accept-by-provider', this.order)
          .then(() => {
            console.log('Success');
            EventBus.$emit('snackbar', {
              text: 'Service Offer successfully submitted',
            });
            this.orderSubmitted = true;
          })
          .catch(error => {
            console.log(error);
          })
          .finally((this.loading = false));
      }
    },
  },
};
</script>
